import { DigitalShareItemType } from "../Enums/DigitalShareItemType";

export interface IDigitalShareItem {
  imgUrl: string;
  isSelected: boolean;
  type: DigitalShareItemType;
  sectionTitle: string;
  captionAboveTitle: string;
  itemTitle: string;
  hideItemTitle?: boolean;
  hideItemText?: boolean;
  hideItem?: boolean;
}

export const createDigitalShareItem = (
    type: DigitalShareItemType,
    isSelected: boolean,
    imgUrl: string,
    sectionTitle: string,
    captionAboveTitle: string,
    itemTitle: string,
    hideItemTitle = false,
    hideItemText = false,
    hideItem = false
): IDigitalShareItem => {
    return {
        imgUrl,
        isSelected,
        type,
        sectionTitle,
        captionAboveTitle,
        itemTitle,
        hideItemTitle,
        hideItemText,
        hideItem,
    };
};
